import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { selectProduct, selectProductImage } from '../../../../../flux/selectors/product'
import { selectHideProductsTitles } from '../../../../../flux/selectors/layout'
import formatPrice from '../../../../../helpers/formatPrice'

import PreviewComponent from './Preview'

const PreviewController = ({
  productId,
  productImage,
  hideProductsTitle,
  name,
  sale,
  price,
  prefixPrice,
  suffixPrice,
  discountedPrice,
}) => (
  <PreviewComponent
    productId={productId}
    productImage={productImage}
    hideProductsTitle={hideProductsTitle}
    name={name}
    sale={sale}
    price={price}
    prefixPrice={prefixPrice}
    suffixPrice={suffixPrice}
    discountedPrice={discountedPrice}
  />
)

PreviewController.propTypes = {
  productId: PropTypes.string.isRequired,
  hideProductsTitle: PropTypes.bool,
  name: PropTypes.string,
  sale: PropTypes.string,
  price: PropTypes.string,
  prefixPrice: PropTypes.string,
  suffixPrice: PropTypes.string,
  productImage: PropTypes.string,
  discountedPrice: PropTypes.string,
}

PreviewController.defaultProps = {
  hideProductsTitle: false,
  name: '',
  sale: '',
  price: '',
  prefixPrice: '',
  suffixPrice: '',
  productImage: '',
  discountedPrice: '',
}

const mapStateToProps = (state, { productId }) => {
  const product = selectProduct(productId)(state)
  if (!product) return {}

  const {
    title,
    settings: {
      price_extended: priceExtended,
      price_prefix: prefixPrice,
      price_suffix: suffixPrice,
      sale,
      starting_price: startingPrice,
    },
  } = product

  const discountedPrice = formatPrice(startingPrice?.digits, startingPrice?.currency_symbol)

  return {
    productId,
    productImage: selectProductImage(productId)(state),
    hideProductsTitle: selectHideProductsTitles(state),
    name: title,
    sale,
    price: formatPrice(priceExtended?.digits, priceExtended?.currency_symbol),
    prefixPrice,
    suffixPrice,
    discountedPrice,
  }
}

PreviewController.displayName = 'Preview'
PreviewController.whyDidYouRender = true

export default connect(mapStateToProps)(
  React.memo(PreviewController),
)
